import React from 'react';
import EyeIcon from 'src/common/utils/TableColumnIcons/EyeIcon';
import TrashIcon from 'src/common/utils/TableColumnIcons/TrashIcon';

export const ActionColumnFormat = (value, row, rowIndex, {onDelete, onEye, canRemove }) => {
	return (
		<>
		<TrashIcon
				onClick={() => onDelete(value)}
				className={canRemove === true ? '' : 'd-none' }
			/>
			<EyeIcon onClick={() => onEye(value)} color="primary" className='ml-2'/>
		</>
	);
};
